﻿export class Age {
  private birthDate: Date;
  private birthYear: number;
  private birthMonth: number;
  private birthDay: number;

  public get Years(): number {
    var today = new Date();
    var age = today.getFullYear() - this.birthYear;
    var monthDifference = today.getMonth() - this.birthMonth;
    var isBeforeBirthMonth = monthDifference < 0;
    var isSameMonthButBeforeBirthday = monthDifference === 0 && today.getDate() < this.birthDay;

    if (isBeforeBirthMonth || isSameMonthButBeforeBirthday) {
      age--;
    }

    if (age < 0)
      return 0;

    return age;
  }
  constructor(birthDate: Date) {
    if (birthDate == null)
      throw new Error('birthDate is required');

    this.birthDate = birthDate;
    this.birthYear = birthDate.getFullYear();
    this.birthMonth = birthDate.getMonth();
    this.birthDay = birthDate.getDate();
  }
}
